// Components
import CarouselAutomation from "components/carousel-automation"
import CalcButton from "components/folder/calc/calc-button"
import Controls from "components/folder/settings/controls/"
// Styles
import { DateText_s, FolderSettingsTable_s, FolderSettingsWrapper_s } from "components/folder/settings/folder-settings-styles"
import NumberInput from "components/inputs/number"
import { Toolbar } from "components/subnav"
import CarouselModal, { CarouselData } from "components/table/carousel/carousel-modal"
import CarouselTrigger from "components/table/carousel/carousel-trigger"
import { DropdownInput } from 'components/table/carousel/inputs'
import { DropdownField } from "components/table/display"
import { DropdownEdit } from "components/table/inputs"
import { field as _field, field_attrs } from "components/table/lib/column-field"
import SearchHeader from "components/table/search-header"
import {
  focusFirstCellByRowIndex, getFocusedRowIndex, getPagingInfo, TableAutomation, unfocusAllCells
} from "components/table/table-automation"
import automationService from "data/automation"
// Data
import carouselService from "data/carousel"
import chartService from "data/chart"
import folderService, { Folder } from "data/folder"
import folderPermissionService from "data/folder-permission"
import keyService, * as chord from "data/key"
import { formatDate } from "data/lib/dates"
import { local } from 'data/lib/local-json'
import portfolioService from "data/portfolio"
import propertyService from "data/property"
import usersService from "data/user"
import userGroupService from "data/user-groups"
import validationService from "data/validate"
import toggles from "feature-toggles"
import { AddIcon } from "images/icons/tools"
import _ from "lodash"
import { Column } from "primereact/column"
import { ContextMenu } from "primereact/contextmenu"
// PR
import { DataTable } from "primereact/datatable"
import React, { useEffect, useRef, useState } from "react"
import Isvg from 'react-inlinesvg'
import { FormRow, FormSection } from "styles/form-styles"
import { InputText_s } from "styles/input-styles"
// Icons


type ContextRow = {
  correlationid: string
}

const tableId = "folderSettingsTable"

const FolderSettings = (props) => {
  const usePrevious = (value) =>{
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const nonSystemMenu = [
    // {label: 'Copy Cell', icon: 'pi pi-fw pi-copy', command: e => { if(contextRow.systeminput === "systemImmutable") return;
    //   copy(contextCell, contextRow)
    // }},
    {label: 'Delete Row', icon: 'pi pi-fw pi-trash', command: e => {
      const pager         = getPagingInfo(tableId);
      const currentRowNum = getFocusedRowIndex() + 1
      const currentRecordIndex = (pager.currentPage > 1 ? (pager.currentPage - 1) * pager.pageSize : 0) + currentRowNum - 1
      showDeleteConfirmation(contextRow, currentRecordIndex + 1)
    }},
  ]

  const [carouselData, updateCarouselData] = useState<CarouselData|null>(null)
  const [data, setData] = useState<object[]|null>(null)
  const [folder, setFolder] = useState<Folder|null>(null)
  const [permissions, setPermissions] = useState<object[]>([])
  const [users, setUsers] = useState<object[]|null>(null)
  const [usergroups, setUserGroups] = useState<object[]|null>(null)
  const [properties, setProperties] = useState<object[]|null>(null)
  const [portfolios, setPortfolios] = useState<object[]|null>(null)
  const [charts, setCharts] = useState<object[]|null>(null)
  const [isAMSubfolder, setIsAMSubfolder] = useState<boolean>(false)
  const [searchFilter, setSearchFilter] = useState<string>("")
  const [contextRow, setContextRow] = useState<ContextRow>({correlationid: ''})
  const [contextCell, setContextCell] = useState<object|null>(null)
  const [deleteConfirmation, setDeleteConfirmation] = useState<JSX.Element | null>(null)
  const prevSearch = usePrevious(searchFilter);
  const [tableAutomationActive, setTableAutomationActive] = useState<boolean>(false)
  const [menu, setMenu] = useState<[]|object[]>(nonSystemMenu)
  const menuRef = useRef<ContextMenu | null>(null)
  const tableRef = useRef() as React.MutableRefObject<DataTable>
  const field = _field('detailAccounts')
  const roleOptions = [
    {label:"Owner", value: "owner"},
    {label:"Read-Only", value: "readonly"},
    {label:"Read-Write", value: "readwrite"},
  ]
  const [_errors, setErrors] = useState<object>({})

  useEffect(() => {
    const validationSubscription = validationService.stream().subscribe(setErrors)
    folder && validationService.fetch('folder', folder.folderid)
    folder && folderService.isAssetManagementSubfolder(folder.folderid).then((res) => {
      setIsAMSubfolder(res)
    })

    return function cleanup(){
      validationSubscription.unsubscribe()
    }
  }, [folder?.folderid])

  useEffect(() => {
    if (prevSearch !== "" && searchFilter === "") _.invoke(tableRef, 'current.filter', '', 'contains');
    else if (searchFilter !== "") _.invoke(tableRef, 'current.filter', searchFilter, 'contains');
    else return
  }, [searchFilter])

  useEffect(() => {
    setMenu(nonSystemMenu)
  }, [contextRow])

  // useEffect(() => {
  //   if(canPaste(contextCell)) {
  //     nonSystemMenu.splice(1, 0, {label: 'Paste Cell', icon: 'pi pi-fw pi-file', command: e => { if(contextRow.systeminput) return;
  //       paste(contextCell, contextRow, folderPermissionService)
  //     }})
  //   }
  //   setMenu(nonSystemMenu)
  // }, [contextCell])

  useEffect(() => {
    const carouselSubscription = carouselService.stream().subscribe(data => {
      updateCarouselData(data);
    })

    const folderSubscription = folderService.stream().subscribe(data => {
      if(data.state === "ok") {
        const currentFolder = folderService.get()
        if(currentFolder && !folder) {
          setFolder(currentFolder)
          if(!permissions || _.get(folder, "folderid") !== currentFolder.folderid) {
            folderPermissionService.fetch(currentFolder.folderid)
          }
        }
      }
    })

    const permissionSubscription = folderPermissionService.stream().subscribe(data => {
      if((data.state === "ok" || data.state === "error") && data.value.length > 0) {
        setPermissions(_.cloneDeep(data.value))
        const currentData = _.get(carouselService.value(), "rowData")
        const updatedRowData = _.find(data.value, (r) => r.correlationid === currentData.correlationid)
        if(updatedRowData) carouselService.updateRowData(updatedRowData)
      }
    })

    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_SHIFT_PLUS && k.down === true:
          if(!window[`${tableId}_carousel_in_focus`]) {
            unfocusAllCells()
            folderPermissionService.create({folderid: _.get(folder, "folderid")})
          }
          break
        case k.chord === chord.CTRL_SHIFT_MINUS && k.down === true:
          if(!window[`${tableId}_carousel_in_focus`]) {
            const pager         = getPagingInfo(tableId);
            const currentRowNum = getFocusedRowIndex() + 1
            const currentRecordIndex = (pager.currentPage > 1 ? (pager.currentPage - 1) * pager.pageSize : 0) + currentRowNum - 1
            const records       = tableRef.current.props.value!;
            const currentRow    = records[currentRecordIndex];
            if (!currentRow.systeminput) showDeleteConfirmation(currentRow, currentRecordIndex + 1)
          }
          break
      }
    })

    const usersSubscription = usersService.stream().subscribe(data => {
      if(data.users.length) {
        setUsers(data.users)
      }
    })

    const usergroupSubscription = userGroupService.stream().subscribe(data => {
      if(_.get(data, "groups.length")) {
        setUserGroups(_.get(data, "groups"))
      }
    })

    const propertySubscription = propertyService.stream().subscribe(data => {
      if(data.value.length) {
        setProperties(data.value)
      }
    })

    const portfolioSubscription = portfolioService.stream().subscribe(data => {
      if(data.value.length) {
        setPortfolios(data.value)
      }
    })

    const chartSubscription = chartService.stream().subscribe(data => {
      if(data.value.length) {
        setCharts(data.value)
      }
    })

    folderService.fetchAllFolders()
    usersService.getUsers()
    userGroupService.fetchUserGroups()
    folder && propertyService.fetchByFolderId(_.get(folder, "folderid"), false)
    portfolioService.fetchPortfolios()
    chartService.fetchCharts()

    return function cleanup() {
      folderSubscription.unsubscribe()
      keySubscription.unsubscribe()
      usersSubscription.unsubscribe()
      usergroupSubscription.unsubscribe()
      propertySubscription.unsubscribe()
      portfolioSubscription.unsubscribe()
      permissionSubscription.unsubscribe()
      chartSubscription.unsubscribe()
    }
  }, [folder?.folderid])

  const persistFolder = (field, value) => {
    const newFolder = _.cloneDeep(folder)
    _.set(newFolder, field, value)
    setFolder(newFolder)
    folderService.patchFolder(newFolder)
  }

  const persistPermission = (value, field, rowData) => {
    if(field === "role") {
      let data = _.cloneDeep(rowData)
      if(value === "owner") {
        let allPropsId = _.get(_.find(portfolios, (p) => p.code === "*AllProperties"), "portfolioid")
        _.set(data, "objects.type", "portfolio")
        _.set(data, "objects.ids", [allPropsId])
      }
      _.set(data, field, value)
      folderPermissionService.patch(data)
    }
  }

  const persistCarousel = (data) => {
    folderPermissionService.patch(data)
    carouselService.updateRowData(data)
  }

  function showDeleteConfirmation(record: ContextRow, currentRow: number) {
    automationService.broadcast("MODAL_OPENING", {})
    setDeleteConfirmation(Controls.DeleteConfirmation({
      show: true,
      close: () => {
        setDeleteConfirmation(null)
        setTimeout(() => automationService.broadcast("MODAL_CLOSING", {}), 200)
      },
      confirm: () => {
        folderPermissionService.del(record)
        setDeleteConfirmation(null)
        setTimeout(() => {
          focusFirstCellByRowIndex(tableId, currentRow - 2 > 0 ? currentRow - 2 : 0)
        }, 200)
      },
      rowNum: currentRow
    }))
  }

  function updateContextMenu(originalEvent){
    if (!menu.length){
      setMenu(nonSystemMenu)
    }
    _.invoke(menuRef.current, "show", originalEvent)
  }

  const rowClassName = (rowData) => {
    return {'' : rowData}
  }

  const Add = () => {
    return (
      <a onClick={() => folderPermissionService.create({folderid: _.get(folder, "folderid")})}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  const attrs = (field) => field_attrs('folder')(field)(folder, props)

  return (
    <FolderSettingsWrapper_s>
      <Toolbar>
        <CalcButton />
      </Toolbar>
      <FormSection className="settings-form">
        <FormRow>
          <div>
            <label htmlFor="codeInput">
              Code
            </label>
            <InputText_s
              id="codeInput"
              className="automated-form"
              value={_.get(folder, "code")}
              onChange={(e) => {
                let f = _.cloneDeep(folder)
                f.code = e.target.value
                setFolder(f)
              }}
              onBlur={e => persistFolder('code', e.target.value)}
              {...attrs('code')}
            />
          </div>
          <div>
            <label htmlFor="nameInput">
              Description
            </label>
            <InputText_s
              id="nameInput"
              className="automated-form"
              value={_.get(folder, "name")}
              onChange={(e) => {
                let f = _.cloneDeep(folder)
                f.name = e.target.value
                setFolder(f)
              }}
              onBlur={e => persistFolder('name', e.target.value)}
              {...attrs('name')}
            />
          </div>
          <div>
            <label htmlFor="reportBegin">
              Report Begin
            </label>
            <DateText_s
              id="reportBegin"
              className="automated-form"
              value={_.get(folder, "reportbegindate")}
              persist={val => persistFolder('reportbegindate', formatDate(val, "YYYY-MM-DD"))}
              withoutDays
              {...attrs('reportbegindate')}
            />
          </div>
          <div>
            <label htmlFor="term">
              Term
            </label>
            <NumberInput
              id="term"
              attrs={attrs}
              className="automated-form"
              field="term"
              value={_.get(folder, "term")}
              persist={(_, val) => persistFolder('term', val)}
            />
          </div>
          {toggles.calcVersionSelector() &&
          <div>
            <label htmlFor="calc-version-input">Calc Version</label>
            <DropdownInput
              className="automated-form"
              attrs={attrs}
              id="calc-version-input"
              field="calcdetail.calcVersion"
              options={[{label: "v1", value: "v1"}, {label: "v2", value: "v2"}]}
              persist={(val) => persistFolder("calcdetail.calcVersion", val)}
              data={folder}
            />
          </div>}
          {toggles.displayAssetManagement() && isAMSubfolder && local('auth.profile')?.assetmanagement &&
          <div>
            <label htmlFor="chart-selector">Chart</label>
            <DropdownInput
              className="automated-form"
              attrs={attrs}
              id="chart-selector"
              field="chartid"
              disabled={_.get(properties, "length")}
              options={_.map(charts, (c) => {return {label: c.code, value: c.chartid}})}
              persist={(val) => persistFolder("chartid", val)}
              data={folder}
            />
          </div>}
        </FormRow>
      </FormSection>
      <Toolbar className="folder-permissions-toolbar">
        <Add />&nbsp;&nbsp;
        <span>Folder Permissions</span>
      </Toolbar>
      <SearchHeader setSearchFilter={setSearchFilter} className="search-embedded"/>
      <ContextMenu model={menu} ref={menuRef} appendTo={document.querySelector("body")} onHide={() => {}}/>
      <FolderSettingsTable_s id="folder-settings-table-scrollable-container">
        <DataTable
          globalFilter={searchFilter}
          id={tableId}
          ref={tableRef}
          value={permissions}
          paginator={true}
          rows={20}
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          scrollable={true}
          paginatorPosition="bottom"
          rowClassName={rowClassName}
          stateStorage="custom"
          onContextMenu={e => menuRef.current ? updateContextMenu(e.originalEvent) : null}
          contextMenuSelection={contextRow}
          onContextMenuSelectionChange={e => {
            setContextRow(e.value)
            setContextCell(e.originalEvent.target)
          }}
          customSaveState={state => localStorage.setItem("primereact-table-preferences", JSON.stringify({rows: state.rows}))}
          customRestoreState={() => JSON.parse(localStorage.getItem("primereact-table-preferences")!)}>
          <Column header="#" style={{width: "45px"}}
            body={(rowData, props) => props.rowIndex + 1}
          />
          <Column style={{minWidth: "250px"}} className="p-editable-column"
            header="Users/Groups"
            {...field('users.type', (rowData, props) =>
              <CarouselTrigger
                field="users.type"
                description={`Permission Row #${props.rowIndex + 1}`}
                title={rowData.users.type === "user" ? "Users" : "User Groups"}
                rowData={rowData}
                persist={persistCarousel}
                componentAtRest={Controls.UsersAtRest}
                controls={{
                  user: {control: Controls.UserPermissions, name: "Users"},
                  usergroup: {control: Controls.UserGroupPermissions, name: "User Groups"},
                }}
                hover={{
                  injected: Controls.UsersHover
                }}
                namedItems={{
                  users,
                  usergroups
                }}
                basicReadonly={[]}
              />
            )}
          />
          <Column style={{minWidth: "225px"}} className="p-editable-column"
            sortable
            header="Data Access"
            {...field('role', (rowData, props) => DropdownField({options: roleOptions, rowData, ...props}))}
            editor={props => <DropdownEdit options={roleOptions} default="" persist={persistPermission} {...props} />}
          />
          <Column style={{minWidth: "250px"}} className="p-editable-column"
            header="Property Access"
            {...field('objects.type', (rowData, props) =>
              <CarouselTrigger
                field="objects.type"
                description={`Permission Row #${props.rowIndex + 1}`}
                title={rowData.objects.type === "property" ? "Property Access" : "Portfolio Access"}
                rowData={rowData}
                persist={persistCarousel}
                disabled={rowData.role === "owner"}
                disabledMessage="Property access must be *AllProperties when data access is set to Owner"
                componentAtRest={Controls.ObjectsAtRest}
                controls={toggles.displayAssetManagement() && local('auth.profile')?.assetmanagement ?
                  {
                    property: {control: Controls.PropertyPermissions, name: "Properties"},
                    portfolio: {control: Controls.PortfolioPermissions, name: "Portfolios"},
                  }
                  :
                  {
                    property: {control: Controls.PropertyPermissions, name: "Properties"},
                  }
                }
                hover={{
                  injected: Controls.ObjectsHover
                }}
                namedItems={{
                  properties,
                  portfolios
                }}
                basicReadonly={[]}
              />
            )}
          />
        </DataTable>
        { deleteConfirmation }
        { carouselData && carouselData['show'] && <CarouselModal code="code" data={carouselData} key="carousel-modal" width={887} /> }
        <div>
          <CarouselAutomation
            outsideTable={true}
            automationActive={!tableAutomationActive && !_.get(carouselData, "show")}
            automationClass="automated-form"
            editableFilters={false}
            includeSearchBar={true}
            tabOut={() => { setTableAutomationActive(true) }}/>
          <TableAutomation tableId={tableId} automationActive={tableAutomationActive} shiftTabOut={() => setTableAutomationActive(false)}/>
        </div>
      </FolderSettingsTable_s>
    </FolderSettingsWrapper_s>
  )
}

export default FolderSettings
